import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./assets/fonts/fonts.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://c243cd0c73de0f2feff61e3402bce15b@o4510306029338624.ingest.us.sentry.io/4510306031042560",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
